export function formatDateSmart(dateLike) {

  const d = new Date(dateLike);

  if (isNaN(d.getTime())) return "";

  const diff = Date.now() - d.getTime();

  const s = Math.floor(diff / 1000);
  if (s < 60) return `${s}s`;

  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m`;

  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;

  return d.toLocaleDateString();
}